import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import type { AgingDetailState } from "../hooks/useAgingDetailState.ts";

export const AgingDetailContext = createContext<AgingDetailState | undefined>(undefined);

const useAgingDetailContext = (): AgingDetailState => {
  const context = defined(
    use(AgingDetailContext),
    "useAgingDetailContext must be used within an AgingDetailContext.Provider"
  );
  return context;
};

export default useAgingDetailContext;
